export default __webpack_public_path__ + "static/logo-full-red-995dc200d27bea64a03433047290a2ce.svg";